export class GenLogEntity{
    id:number;
    personId:number;
    loginDate:string;

    constructor(){}
}